import moment from 'moment';
import i18n from 'i18next';

// Import moment locales
import 'moment/locale/pl';
import 'moment/locale/en-gb';

/**
 * Maps i18n language codes to moment locale codes
 * @param {string} language - i18n language code
 * @returns {string} moment locale code
 */
const mapLanguageToMomentLocale = language => {
  if (language.startsWith('pl')) {
    return 'pl';
  } else if (language.startsWith('en')) {
    return 'en';
  }
  return 'en'; // default fallback
};

/**
 * Sets moment locale based on current i18n language
 * @returns {string} The applied locale code
 */
export const setMomentLocale = () => {
  const currentLanguage = i18n.language || 'en-US';
  const momentLocale = mapLanguageToMomentLocale(currentLanguage);
  moment.locale(momentLocale);
  return momentLocale;
};

// Configure the language change listener immediately when this module is loaded
if (typeof window !== 'undefined' && i18n.on) {
  // Set initial locale
  setMomentLocale();

  // Listen for language changes
  i18n.on('languageChanged', lng => {
    const newMomentLocale = mapLanguageToMomentLocale(lng);
    moment.locale(newMomentLocale);
  });
}
